const fortraders_es = require('./4traders.json')
export default fortraders_es